import Vue from "vue";
import Vuetify from "vuetify/lib";
import es from "vuetify/lib/locale/es";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const opts = {
  theme: {
    //dark:true
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#d3ab3e",
        secondary: "#6d6d6d",
        accent: "#ffab40",
        error: "#f44336",
        info: "#2196f3",
        success: "#4caf50",
        warning: "#ff9800",
      },
    },
  },
  lang: {
    locales: { es },
    current: "es",
  },
  icons: {
    iconfont: "md",
  },
};

export default new Vuetify(opts);
